/**
 * ThemeToggleWidget · Sidebar foot theme switcher.
 *
 * slot_theme_inkteal_indigo (29 JUN 2026): на 5 тем cycle-кнопка стала неудобной —
 * теперь это поповер-пикер (см. ThemeMenu, variant="rail"). Триггер по-прежнему
 * последняя кнопка `.rail-foot` (data-theme-toggle / data-testid сохранены).
 *
 * Renders null вне ThemeProvider (ThemeMenu использует useThemeOptional) — partial
 * mount фикстуры (NavShell.test.tsx Sidebar smoke) остаются зелёными.
 */

import { ThemeMenu } from './ThemeMenu';
import { THEME_CYCLE } from '@/types';

export function ThemeToggleWidget() {
  return <ThemeMenu variant="rail" />;
}

/** Re-export the cycle order const so existing test imports keep working. */
export { THEME_CYCLE };
